<template>
  <div class="bg-sidebar-link-background-active flex h-[56px] w-[64px] items-center justify-center">
    <ui-goal
      :key="goal"
      v-tippy="{ placement: 'right', content: goalTooltip, delay, offset: [0, 14] }"
      :goal="goal"
      dark
      :action-count="reviewCount"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { UiGoal } from '@klausapp/ui-kit'
import i18n from '@/i18n'
import { delay } from '@/components/Tippy'
import { useUserGoal } from '@/composables/useUserGoal'

const goal = ref(0)
const reviewCount = ref(0)
const goalTooltip = ref('')

const [userGoal] = useUserGoal()

watch(
  userGoal,
  (val, previous) => {
    if (!val) return
    const { goal: newGoal, reviewCount: newReviewCount, goalType } = val
    const { goal: previousGoal, reviewCount: previousCount } = previous || {}
    goal.value = newGoal
    reviewCount.value = newReviewCount

    if (goalType === 'UNKNOWN') return

    const period = {
      DAILY: i18n.t('modules.application.navbar.goal_daily'),
      WEEKLY: i18n.t('modules.application.navbar.goal_weekly'),
      MONTHLY: i18n.t('modules.application.navbar.goal_monthly'),
    }[goalType || 'WEEKLY']

    goalTooltip.value = i18n.t('modules.application.navbar.review_goal', {
      n: newReviewCount,
      total: newGoal.toString(),
      period,
    })

    if (newReviewCount >= newGoal && (previousCount || 0) < (previousGoal || 0)) throwConfetti()
  },
  { immediate: true },
)

const throwConfetti = async () => {
  const { confettiParty } = await import('../utils/confetti')
  confettiParty()
  setTimeout(confettiParty, 1200)
}
</script>
